//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { TableBody as MuiTableBody } from '@mui/material';

type TableBodyProps = {
  children: React.ReactNode;
};

const TableBody = React.forwardRef(({ children, ...props }: TableBodyProps, ref: React.Ref<HTMLTableSectionElement>) => {
  return (
    <MuiTableBody {...props} ref={ref} style={{ overflow: 'hidden' }}>
      {children}
    </MuiTableBody>
  );
});

export default TableBody;
